import React, { Component } from "react";
import { Link } from "react-router-dom";
import HouseDetailPageInfo from "../../data/HouseDetailPageInfo";

class PortfolioMasonry extends Component {
  render() {
    const { column } = this.props;
    const list = HouseDetailPageInfo.slice(
      0,
      this.props.item || HouseDetailPageInfo.length
    );

    return (
      <React.Fragment>
        {list.map((house, index) => {
          const coverImage =
            house.content.find((c) => c.type === "image")?.src ||
            house.PortfolioList2?.[0]?.image;

          return (
            <div className={`${column}`} key={index}>
              <div className="Tilt-inner">
                <div className="portfolio">
                  <div className="thumbnail-inner">
                    <div className="thumbnail">
                      <img src={coverImage} alt={house.title} />
                    </div>
                  </div>
                  <div className="content">
                    <div className="inner">
                      <p>{house.description}</p>
                      <h4>
                        <Link
                          to={{
                            pathname: `/${house.slug}`,
                            state: { blog: house },
                          }}
                        >
                          {house.title}
                        </Link>
                      </h4>
                      <div className="portfolio-button">
                        <Link
                          className="rn-btn"
                          to={{
                            pathname: `/${house.slug}`,
                            state: { blog: house },
                          }}
                        >
                          Case Study
                        </Link>
                      </div>
                    </div>
                  </div>
                  <Link
                    className="link-overlay"
                    to={{
                      pathname: `/${house.slug}`,
                      state: { blog: house },
                    }}
                  ></Link>
                </div>
              </div>
            </div>
          );
        })}
      </React.Fragment>
    );
  }
}

export default PortfolioMasonry;
